module.exports = __webpack_public_path__ + "img/img-flow-3.5801b306.png";